var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('HeaderMobile',{attrs:{"links":_vm.links},on:{"logout":_vm.logout}}):_c('HeaderDesktop',{attrs:{"links":_vm.links},on:{"logout":_vm.logout}}),_c('main',{staticClass:"pa-0 ma-0"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }